// extracted by mini-css-extract-plugin
export var aiStarIcon = "_j2-2";
export var container = "_j2-4";
export var dismissButton = "_j2-3";
export var hasPaddingBottom = "_j2-6";
export var last = "_j2-e";
export var scrollbarThumb = "_j2-c";
export var scrollbarTrack = "_j2-b";
export var selected = "_j2-9";
export var spin = "_j2-1";
export var spinning = "_j2-0";
export var suggestionItem = "_j2-d";
export var suggestionsPanel = "_j2-5";
export var tonePill = "_j2-8";
export var tonesContainer = "_j2-7";
export var unselected = "_j2-a";